'use strict';

var angular = require('angular');
var gridColumns = require('../config/price-recommendation-services-analysis-grid-columns');
var gridDataFields = require('../config/price-recommendation-services-analysis-grid-data-fields');
var _ = require('lodash');
var PriceRecommendationServicesAnalysisGridController = function PriceRecommendationServicesAnalysisGridController($scope, $filter, $q, dataRetriever, hepService, pricingAnalysisCommonsDataService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var COLUMNS_TO_HIDE_IF_EMPTY = ['ppsValue', 'bvAdjustment', 'todBank', 'weight'];
  var source = {
    localdata: [],
    datafields: gridDataFields.datafields,
    datatype: 'array'
  };
  var cellClassName = function cellClassName(rowId, datafield, value, row) {
    return row.itinNumber % 2 === 0 ? 'even-service-pair' : 'odd-service-pair';
  };
  function prepareColumns() {
    return _.transform(gridColumns.columns, function (result, column) {
      column.cellclassname = cellClassName;
      result.push(column);
    }, []);
  }
  function prepareColumnGroups() {
    return gridColumns.columngroups;
  }
  $scope.gridId = 'price-recommendation-services-analysis-grid';
  $scope.directionFilter = 'both';
  $scope.gridSettings = {
    width: '100%',
    height: 250,
    columnsresize: true,
    altrows: true,
    enablehover: false,
    columns: prepareColumns(),
    columngroups: prepareColumnGroups(),
    filterable: true,
    sortable: true,
    source: new angular.element.jqx.dataAdapter(source)
  };
  $scope.resetGrid = function () {
    source.localdata = [];
    $scope.gridSettings.columns = prepareColumns();
  };
  function populateGridTitle(service, benchmarkCarriers) {
    $scope.title = {
      flightNumber: service.displayServiceId,
      departureTime: rmMomentFormat(service.departureTime, 'TIME_USER_SETTINGS'),
      market: service.marketOrigin + '-' + service.marketDestination,
      pos: service.pos,
      origClass: service.initialOriginalClass,
      latestClassSource: service.latestClassSource,
      recClass: service.recommendedClass,
      effectiveFareChange: service.effectiveFareChange,
      benchmarkCarriers: benchmarkCarriers,
      riaMethod: service.riaMethod,
      medianFareChange: service.medianFareChange,
      recomFareMethod: service.recomFareMethod,
      carryCount: service.carryCount
    };
  }
  $scope.onDirectionFilter = function (filter) {
    $scope.directionFilter = filter;
    $scope.retrieveData($scope.originalService, $scope.$parent.snapshotDate);
  };
  function filterDirection(responses) {
    if (!$scope.isBothDirections) {
      $scope.directionFilter = 'none';
    }
    var filterMethods = {
      inboundOnly: function inboundOnly(direction) {
        return _.lowerCase(direction) === 'inbound';
      },
      outboundOnly: function outboundOnly(direction) {
        return _.lowerCase(direction) === 'outbound';
      },
      both: function both() {
        return true;
      },
      none: function none() {
        return true;
      }
    };
    var filterMethod = filterMethods[$scope.directionFilter];
    responses.gridData = _.filter(responses.gridData, function (data) {
      return filterMethod(data.direction);
    });
    return responses;
  }
  function hideEmptyColumns(responses) {
    _.each(COLUMNS_TO_HIDE_IF_EMPTY, function (field) {
      var noDataPresent = !_.find(responses.gridData, field);
      _.find($scope.gridSettings.columns, {
        datafield: field
      }).hidden = noDataPresent;
    });
  }
  $scope.retrieveData = function (originalService, snapshotDate) {
    originalService = originalService || $scope.originalService;
    $scope.isBothDirections = !pricingAnalysisCommonsDataService.isSingleItinerary(originalService);
    $scope.resetGrid();
    $scope.gridSettings.jqxGrid({
      source: new angular.element.jqx.dataAdapter(source),
      columns: $scope.gridSettings.columns
    });
    $q.all({
      benchmarkCarriers: hepService.getBenchmarkCarriers(originalService.marketOrigin, originalService.marketDestination, originalService.cabinCode),
      gridData: dataRetriever.getData(originalService, snapshotDate)
    }).then(filterDirection).then(function (responses) {
      populateGridTitle(originalService, _.get(responses.benchmarkCarriers, 'hepList.0.properties.benchmarkCarriers', ''));
      hideEmptyColumns(responses);
      $scope.originalService = originalService;
      source.localdata = responses.gridData;
      $scope.gridSettings.source.dataBind();
    });
  };
};
PriceRecommendationServicesAnalysisGridController.$inject = ['$scope', '$filter', '$q', 'PriceRecommendationServicesAnalysisGridDataRetrieverService', 'HepService', 'PricingAnalysisCommonsDataService'];
module.exports = PriceRecommendationServicesAnalysisGridController;